<template>
  <!-- 遮罩 begin -->
  <MaskLayer
    class="position-absolute"
    style="max-height:100%"
  >
    <!-- 獎品名稱 begin -->
    <div
      class="bg-white d-flex flex-column pt-3 rounded-md text-center"
      style="width: 90%; max-width: 560px; max-height: 95vh;"
    >
      <PerfectScrollbar class="text-center px-3 px-md-4 flex-grow-1">
        <!-- 標題文字/標題圖片 begin -->
        <div class="w-100 px-5">
          <h5 class="mb-0">
            {{ $t('activity.congratuation-on-getting') }}
          </h5>
          <h3 class="mb-3">
            {{ item.itemInfo.name }}
          </h3>
          <div class="mx-auto">
            <img
              class="mw-100 mb-3"
              :src="item.itemInfo.image"
              alt=""
            >
          </div>
          <div
            v-if="awardType === 3"
            class="font-size-md text-gray600"
          >
            {{ $t('global.Edenred-Popup-Desc') }}
          </div>
        </div>
        <!-- 標題文字/標題圖片 end -->
        <!-- 領取列表 begin -->
        <div
          v-if="awardType === 2"
          class="my-3"
        >
          <template v-for="(point, index) in item.itemInfo.linePoint">
            <!-- 領取 begin -->
            <div
              :key="index"
              class="rounded-lg shadow-custom p-3 my-3"
            >
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span
                    class="mr-1 image-panel image-panel-n2 rounded-pill font-size-base text-white"
                    style="background:#00C300;"
                  >P</span>
                  <span class="mx-1"><h5 class="mb-0">{{ point.point | currency }}</h5></span>
                </div>
                <div class="d-flex align-items-center justify-content-between overflow-hidden bg-gray200 rounded-pill flex-grow-1 ml-3 ">
                  <div class="mx-3 text-truncate-1">
                    {{ point.serialNo }}
                  </div>
                  <b-button
                    class="px-4 text-nowrap"
                    pill
                    style="background: rgba(0, 191, 175, 1.0); border-color: rgba(0, 191, 175, 1.0)"
                    @click="goToExchange(point.serialNo)"
                  >
                    {{ $t('global.receive') }}
                  </b-button><!-- 色碼同行動呼籲按鈕，不改變形狀 -->
                </div>
              </div>
            </div>
            <!-- 領取 end -->
          </template>
        </div>
        <div
          v-if="awardType === 3"
          class="my-3"
        >
          <template v-for="(edenred, index) in item.itemInfo.edenred">
            <!-- 領取 begin -->
            <div
              :key="index"
              class="rounded-lg shadow-custom p-3 my-3"
            >
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="mx-1"><h5 class="mb-0">{{ $t('global.password') }}</h5></span>
                </div>
                <div class="d-flex align-items-center justify-content-between overflow-hidden bg-gray200 rounded-pill flex-grow-1 ml-3 ">
                  <div class="mx-3 text-truncate-1">
                    {{ edenred.password }}
                  </div>
                  <b-button
                    class="px-4 text-nowrap"
                    pill
                    style="background: rgba(0, 191, 175, 1.0); border-color: rgba(0, 191, 175, 1.0)"
                    @click="goToExchangeForEdenred(edenred.url,edenred.password)"
                  >
                    {{ $t('global.copy-gotoUrl') }}
                  </b-button><!-- 色碼同行動呼籲按鈕，不改變形狀 -->
                </div>
              </div>
            </div>
          </template>
        </div>
        <!-- 領取列表 end -->
      </PerfectScrollbar>
      <div class="p-3">
        <b-button
          pill
          class="w-100"
          :style="{background: `rgba(${entertainmentInfo.resultColor}, 1.0)`, 'border-color': `rgba(${entertainmentInfo.resultColor}, 1.0)` ,color: `rgba(${entertainmentInfo.resultColor === '255,255,255' ? '45,167,193' :'255,255,255'},1.0)`}"
          @click="confirm"
        >
          {{ $t('global.complete') }}
        </b-button><!-- 色碼同行動呼籲按鈕, 形狀：pill/空值/squared -->
      </div>
    </div>
    <!-- 獎品名稱 end -->
  </MaskLayer>
  <!-- 遮罩 end -->
</template>

<script>
//  因有多人同時在改此專案 暫時不修改Component名子 但此Component為LinePoint與Edenred共用
import MaskLayer from '@/components/MaskLayer.vue';
import PerfectScrollbar from '@/components/PerfectScrollbar.vue';
import paramGetter from '@/utils/paramGetter';

export default {
  components: {
    MaskLayer,
    PerfectScrollbar,
  },
  props: {
    // 中獎商品資訊
    item: {
      type: Object,
      required: true,
    },
    // 活動資料
    activity: {
      type: Object,
      required: true,
    },
    /**
       * 獎品分類，因Edenred的板跟LinePoint相同
       * 2. line point
       * 3. Edenred
       */
    awardType: {
      type: Number,
    },
  },
  data() {
    return {
      // ACT參數
      parameters: [],
    };
  },
  computed: {
    // 娛樂活動資料(刮刮樂...)
    entertainmentInfo() {
      const vm = this;
      switch (vm.activity.categoryID) {
        // 刮刮樂
        case 'Scratchoff':
          return vm.activity.scratchOffInfo;
        // 拉霸
        case 'Slot':
          return vm.activity.slotInfo;
        case 'Roulette':
          return vm.activity.rouletteInfo;
        default:
          return {};
      }
    },
  },
  created() {
    const vm = this;
    vm.$store.dispatch('getAllParameter').then(
      (parameters) => {
        vm.parameters = parameters;
      },
    );
  },
  methods: {
    // Edenred 要複製密碼後關閉並透過外部瀏覽器，開啟Edenred頁面
    goToExchangeForEdenred(url, password) {
      if (url.includes('?')) {
        url = `${url}&openExternalBrowser=1`;
      } else {
        url = `${url}?openExternalBrowser=1`;
      }
      this.copyPassword(password);
      window.open(url);
    },
    copyPassword(password) {
      const isIos = navigator.userAgent.match(/ipad|iphone/i);
      const textarea = document.createElement('textarea');
      // create textarea
      textarea.value = password;
      document.body.appendChild(textarea);
      // select text
      if (isIos) {
        const range = document.createRange();
        range.selectNodeContents(textarea);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        textarea.setSelectionRange(0, 999999);
      } else {
        textarea.select();
      }
      // copy selection
      document.execCommand('copy');
      // cleanup
      document.body.removeChild(textarea);
    },
    // 前往兌換頁
    goToExchange(serialNo) {
      // 前往LINEPOINT 兌換頁
      const vm = this;
      // 需要在外部瀏覽器開，加上openExternalBrowser=1
      const url = `${paramGetter.getValue(vm.parameters, 'LinePointUrl')}${serialNo}&openExternalBrowser=1`;
      // 另開新頁 前往兌換line point
      window.open(url);
    },
    // 確定按鈕
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>
